import { getOrderStatus, postNoPreviousInsurancePolicy, uploadFiles } from '@/api/legacyAPI';
import { CompleteStatuses } from '@/core/docs';
import { jsonToFormData } from '@/core/helpers';
import { useCheckoutStore } from '@/stores/checkout';

export const CompleteService = () => {
	const checkOrderStatus = async (fid, dc, category) => {
		const checkoutStore = useCheckoutStore();

		try {
			checkoutStore.checkoutLoading = true;
			const resp = await getOrderStatus(fid, dc, category);

			return {
				step: resp.step,
				status: resp.status,
				price: resp.price,
				documents: resp.documents,
				paymentLink: resp.payment_link,
				paymentCode: resp.payment_code,
				isKlarnaEligible: resp.is_klarna_eligible,
				hasSpecifiedInfo: resp.specified_info
			};

		} finally {
			checkoutStore.checkoutLoading = false;
		}
	};

	const uploadOrderDocuments = async ({ documents, offerCode }) => {
		const checkoutStore = useCheckoutStore();

		try {
			checkoutStore.checkoutLoading = true;

			const payload = {
				offer_code: offerCode,
				update_status: true,
				send: null,
			};

			const formDataPayload = jsonToFormData(payload);
			(documents ?? []).forEach((doc) => {
				const file = doc?.file ?? null;
				if (!file) {
					return;
				}

				const key = doc?.key;
				const filename = key ? `${key}_${file.name}` : file.name;
				
				formDataPayload.append('file_upload[]', file, filename);
			});

			return await uploadFiles(formDataPayload);
		} finally {
			checkoutStore.checkoutLoading = false;
		}
	};

	const reportNoPreviousInsurancePolicy = async ({ offerCode, hasPreviousPolicy, offerStatus = null }) => {
		const checkoutStore = useCheckoutStore();

		if (offerStatus === CompleteStatuses.ACCEPTED) {
			return null;
		}

		try {
			checkoutStore.checkoutLoading = true;
			return await postNoPreviousInsurancePolicy(offerCode, hasPreviousPolicy);
		} finally {
			checkoutStore.checkoutLoading = false;
		}
	};

	return {
		checkOrderStatus,
		uploadOrderDocuments,
		reportNoPreviousInsurancePolicy,
	};
};

export default CompleteService;
